const routes = [
  {
    path: '/personResearch', // 人员名单管理
    name: 'personResearch',
    component: () => import('./view/Index.vue'),
    meta: {
      requireAuth: false,
      // routerAlive: true
    }
  }
]

export default routes